"use client";

import { ButtonNova } from "@/components/ui-kit/ButtonNova/ButtonNova";
import { TextElementNova } from "@/components/ui-kit/TextElementNova/TextElementNova";
import { useNavigation } from "@/hooks/useNavigation";
import { GA4 } from "@/utils/ga4Utils";
import { cn } from "@/utils/general";

const strandSerumUrl = "/hair/women/product/scalp/strand-serum/";
const buttonLabel = "Learn More";

interface StrandSerumNavBannerProps {
  className?: string;
  onNavigate?: () => void;
}

const StrandSerumNavBanner = ({ className, onNavigate }: StrandSerumNavBannerProps) => {
  const navigate = useNavigation();

  const handleOnClick = () => {
    GA4.onMarketingCtaClicked({
      destination: strandSerumUrl,
      module_location: "navigation",
      text: buttonLabel,
      type: "banner",
    });

    navigate(strandSerumUrl);
    onNavigate?.();
  };

  return (
    <div
      className={cn(
        "bg-cover bg-center bg-no-repeat",
        "bg-[url('https://images.ctfassets.net/0rbfqd9c4jdo/2hM8WaCqcI4y1k6DDwLEBL/85feee4871fa570fa78bdc4e0ea1f867/strand_serum_nav_mobile.jpg')]",
        "md:bg-[url('https://images.ctfassets.net/0rbfqd9c4jdo/61Eop2AbQYB26955aHQMf3/d1401896b0cb124a04d1a5f86e868286/strand_serum_nav_tablet.jpg')]",
        "cursor-pointer rounded h-[130px] md:h-auto md:w-full md:max-w-[279px] lg:max-w-[356px]",
        className
      )}
      onClick={handleOnClick}
    >
      <div className="h-full w-full flex flex-col p-4 md:px-6 lg:p-6 justify-between md:items-center">
        <div className="flex flex-col gap-1 md:gap-2 lg:gap-0">
          <TextElementNova
            text="New! Strand Serum"
            className="Body-30-Dia-Strong text-nova-base-white md:text-center"
          />
          <TextElementNova
            text="For 6x stronger hair<br class='hidden lg:block' /> that can<br class='lg:hidden' /> grow longer.<sup>1</sup>"
            className="text-nova-base-white md:text-center"
            classes={{
              default: "Body-10-Dia-Normal",
              768: "Body-20-Dia-Normal",
              1024: "Body-20-Dia-Normal",
            }}
          />
        </div>
        <div>
          <ButtonNova
            label={buttonLabel}
            icon="Right"
            level="Tertiary"
            copyClassName="text-nova-base-white"
            // The onClick is handled by the BannerWrap component
            tabIndex={-1}
            aria-hidden="true"
          />
        </div>
      </div>
    </div>
  );
};

export default StrandSerumNavBanner;
